module.exports = __webpack_public_path__ + "img/landing-social-screen-2.7bb5d379.png";